import styled from '@emotion/styled';
export const StyledIconContainer = styled.div `
  position: relative;
  width: ${({ theme }) => theme.spacing[600]};
  height: ${({ theme }) => theme.spacing[600]};
`;
export const StyledSubIcon = styled.div `
  position: absolute;
  top: ${({ theme }) => `calc(${theme.spacing[200]} * -1)`};
  right: ${({ theme }) => `calc(${theme.spacing[200]} * -1)`};
`;
//# sourceMappingURL=AccountMenuIcon.styled.js.map